import React from "react";
import OrderDetail from "../../../components/user/expeditionProcess/expeditionProcessDetail";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const DetailOrderPage = () => {
  const { uuid } = useParams();
  return (
    <Layout
      body={
        <>
          <OrderDetail uuid={uuid} />
        </>
      }
    />
  );
};

DetailOrderPage.propTypes = {};

export default DetailOrderPage;

